import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../../components/Topbar/Topbar";
import moment from "moment";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../../assets/img";
import { Select, MenuItem } from "@mui/material";
import { Table } from "../../../components/Table/Table";
import { useGlobalContext } from "../../../Services/PaginationGlobal";
import BookingView from "../../Bookings/BookingView";
import UserBookingTransaction from "../../Bookings/UserBookingTransaction";

function CustomerView() {
  const location = useLocation();
  const type = location?.state?.type;
  const { paginationData } = useGlobalContext();
  const path = location.pathname?.replace("/", "");
  const navigate = useNavigate();
  const [searchs, setSearch] = useState("");
  // View toggles, filters, and data
  const [label, setIsLabel] = useState("Profile Details");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [propertyID, setPropertyID] = useState("");
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [deletePopup, setDeletePopup] = useState(false);
  const [popupLabel, setPopupLabel] = useState(null);
  const [popup, setPopup] = useState(false);
  const [bookingList, setIsBookingList] = useState([]);
  // Table data
  const propertyList = [
    {
      "S.No": 1,
      "Booked Date": "12/02/25",
      "Booking ID": "Rob90",
      "Property Name": "Sunshine (2234242342)",
      "No of Booked Rooms": 20,
      "Service Category": "Room Booking",
      "Room Category": "Standart",
      "Property Price": 20000,
      "Paid Amount": 10000,
      Slot: "22 hrs (M) (6am-4am)",
      "Balance Amount": 5000,
      "Current Status": "Up Coming",
      Status: "Booked",
    },
    {
      "S.No": 2,
      "Booked Date": "12/02/25",
      "Booking ID": "Thor91",
      "Property Name": "Sunshine (2234242342)",
      "No of Booked Rooms": 10,
      "Service Category": "Room Booking",
      "Room Category": "Standart",
      "Property Price": 20000,
      "Paid Amount": 10000,
      Slot: "22 hrs (M) (6am-4am)",
      "Balance Amount": null,
      "Current Status": "Checkin",
      Status: "Hold",
    },
    {
      "S.No": 3,
      "Booked Date": "12/02/25",
      "Booking ID": "Thor91",
      "Property Name": "Sunshine (2234242342)",
      "No of Booked Rooms": 10,
      "Service Category": "Room Booking",
      "Room Category": "Standart",
      "Property Price": 20000,
      "Paid Amount": 10000,
      Slot: "22 hrs (M) (6am-4am)",
      "Balance Amount": 10000,
      "Current Status": "Completed",
      Status: "Booked",
    },
    {
      "S.No": 4,
      "Booked Date": "12/02/25",
      "Booking ID": "Thor91",
      "Property Name": "Sunshine (2234242342)",
      "No of Booked Rooms": 10,
      "Service Category": "Room Booking",
      "Room Category": "Standart",
      "Property Price": 20000,
      "Paid Amount": 10000,
      Slot: "22 hrs (M) (6am-4am)",
      "Balance Amount": 10000,
      "Current Status": "Checkin",
      Status: "Booked",
    },
    {
      "S.No": 5,
      "Booked Date": "12/02/25",
      "Booking ID": "Thor91",
      "Property Name": "Sunshine (2234242342)",
      "No of Booked Rooms": 10,
      "Service Category": "Room Booking",
      "Room Category": "Standart",
      "Property Price": 20000,
      "Paid Amount": 10000,
      Slot: "22 hrs (M) (6am-4am)",
      "Balance Amount": 10000,
      "Current Status": "Cancelled",
      Status: "Cancelled",
    },
  ];
  const bookingLists = [
    {
      SNo: "01",
      TransactionDate: "12/03/25",
      TransactionID: "VOWB00925",
      Property: "Sunshineashdjshjdsaj Villa VOWB00925",
      Owner: "Kumar VOWB00925",
      BookingId: "223322",
      ServiceType: "Room Booking",
      RoomType: "Deluxe",
      City: "Chennai",
      HotelCategory: "Villa",
      PropertyPrice: 1000,
      PaidAmount: 1000,
      BalanceAmount: 50,
      Slot: "22 hrs (M) (9am - 7am)",
      Status1: "Check In",
      Status2: "Booked",
    },
    // ...rest of list unchanged
  ];
  const walletList = [
    {
      "S.No": "01",
      State: "Tamil Nadu",
      City: "Chennai",
      "Property ID": "Sunrise Rob90",
      Type: "Cancellation",
      "Booking ID": "33553523",
      Amount: 500,
      "Generated Date": "12/02/25",
      "Created by": "Admin",
      Status: "-",
    },
    // ...rest of list unchanged
  ];

  // Rows for dropdown Selects
  const users = [
    { id: 1, name: "Chennai" },
    { id: 2, name: "Banglore" },
    { id: 3, name: "Hyderabad" },
    { id: 4, name: "Nellore" },
    { id: 5, name: "Guntur" },
  ];

  // Handler for tab switching
  const handlerChangeLabel = (ele) => {
    setIsLabel(ele);
    // If you want to route on tab change, uncomment below
    // if (ele === "Booking Detail" || ele === "Booking Transaction") {
    //   navigate("/booking-list-view", { state: { type: ele } });
    // }
  };

  // Column configs (unchanged except for minor fixes)
  const columnsProfile = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => <p>{row.index + 1}</p>,
    },
    {
      Header: "User ID",
      accessor: "code",
      Cell: ({ value }) => <p>{value}</p>,
    },
    { Header: "Name", accessor: "name", Cell: ({ value }) => <p>{value}</p> },
    {
      Header: "Email ID",
      accessor: "email",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Mobile Number",
      accessor: "mobile",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "WhatsUp Number",
      accessor: "whatsapp_no",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Gender",
      accessor: "gender",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "State",
      accessor: "state_name",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "City",
      accessor: "city_name",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Current City/Area",
      accessor: "current_city",
      Cell: ({ value, row }) => (
        <p className={"text-center"}>
          {value} / {row.original.current_area}
          {/* {value ? value : "-"} */}
        </p>
      ),
    },
    {
      Header: "Pin Code",
      accessor: "pin_code",
      Cell: ({ value }) => <p>{value ? value : "-"}</p>,
    },
    {
      Header: "Booking Count",
      accessor: "Booking Count",
      Cell: ({ value }) => <p>{value ? value : "-"}</p>,
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => (
        <button className={value === 2 ? "deactive-btn" : "active-btn"}>
          {value === 2 ? "De-active" : "Active"}
        </button>
      ),
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => (
        <div className="d-flex ac-js gap-3">
          <button
            onClick={() =>
              navigate("/customer-view", {
                state: {
                  type: { ...row.original, ...row.original?.user_details },
                },
              })
            }
            className="cust-btn"
          >
            <img src={view_icon} alt="View" className="edit-btn" />
          </button>
          <button
            onClick={() =>
              navigate("/customer-view", {
                state: {
                  type: { ...row.original, ...row.original?.user_details },
                },
              })
            }
            className="cust-btn"
          >
            <img src={edit_icon} alt="Edit" className="edit-btn" />
          </button>
          <button
            onClick={() => setDeletePopup(row.original.id)}
            className="cust-btn"
          >
            <img src={delete_icon} alt="Delete" className="edit-btn" />
          </button>
        </div>
      ),
    },
  ];

  const bookingDetail = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => <p>{row.index + 1}</p>,
    },
    {
      Header: "Booked date",
      accessor: "Booked Date",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Booking Id",
      accessor: "Booking ID",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Property Name",
      accessor: "Property Name",
      Cell: ({ value }) => <p style={{ color: "#AE55F5" }}>{value}</p>,
    },
    {
      Header: "No of Booked Rooms",
      accessor: "No of Booked Rooms",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Service Category",
      accessor: "Service Category",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Room Category",
      accessor: "Room Category",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Property Price",
      accessor: "Property Price",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Paid Amount",
      accessor: "Paid Amount",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Slot",
      accessor: "Slot",
      Cell: ({ value }) => <p style={{ width: "145px" }}>{value}</p>,
    },
    {
      Header: "Balance amount",
      accessor: "Balance Amount",
      Cell: ({ value }) => <p>{value || "-"}</p>,
    },
    {
      Header: "Current Status",
      accessor: "Current Status",
      Cell: ({ value }) => (
        <p
          className="fs-xl-13"
          style={{
            background: "#5D5FEF",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: 9,
          }}
        >
          {value}
        </p>
      ),
    },
    {
      Header: "Status",
      accessor: "Status",
      Cell: ({ value }) => (
        <p
          style={{
            background:
              value === "Booked"
                ? "#5D5FEF"
                : value === "Hold"
                  ? "#FFA721"
                  : "red",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: 9,
          }}
        >
          {value}
        </p>
      ),
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => (
        <div className="d-flex ac-js gap-3">
          <button
            onClick={() =>
              navigate("/booking-list-view", {
                state: {
                  type: { ...row.original, ...row.original?.user_details },
                },
              })
            }
            className="cust-btn"
          >
            <img src={view_icon} alt="View" className="edit-btn" />
          </button>
        </div>
      ),
    },
  ];

  const columnsBooking = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => <p>{row.index + 1}</p>,
    },
    {
      Header: "Transaction date",
      accessor: "TransactionDate",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Transaction Id",
      accessor: "TransactionID",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Property",
      accessor: "Property",
      Cell: ({ value }) => <p style={{ color: "#AE55F5" }}>{value}</p>,
    },
    { Header: "Owner", accessor: "Owner", Cell: ({ value }) => <p>{value}</p> },
    {
      Header: "BookingId",
      accessor: "BookingId",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "ServiceType",
      accessor: "ServiceType",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "RoomType",
      accessor: "RoomType",
      Cell: ({ value }) => <p>{value}</p>,
    },
    { Header: "City", accessor: "City", Cell: ({ value }) => <p>{value}</p> },
    {
      Header: "HotelCategory",
      accessor: "HotelCategory",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "PropertyPrice",
      accessor: "PropertyPrice",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "PaidAmount",
      accessor: "PaidAmount",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "BalanceAmount",
      accessor: "BalanceAmount",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Slot",
      accessor: "Slot",
      Cell: ({ value }) => <p style={{ width: "145px" }}>{value}</p>,
    },
    {
      Header: "Status1",
      accessor: "Status1",
      Cell: ({ value }) => (
        <p
          style={{
            background: value !== "-" ? "#5D5FEF" : "",
            color: value !== "-" ? "#fff" : "#000",
            padding: "10px 20px",
            borderRadius: 9,
            padding: "10px 1px",
            borderRadius: "9px",
            width: "100%",
            textAlign: "center",
          }}
        >
          {value || "-"}
        </p>
      ),
    },
    {
      Header: "Status",
      accessor: "Status2",
      Cell: ({ value }) => (
        <p
          style={{
            background:
              value === "Booked"
                ? "#5D5FEF"
                : value === "Hold"
                  ? "#FFA721"
                  : "red",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: 9,
          }}
        >
          {value}
        </p>
      ),
    },
    {
      Header: "View",
      accessor: "action",
      Cell: ({ row }) => (
        <div className="d-flex ac-js gap-3">
          <button
            onClick={() =>
              navigate("/customer-view", {
                state: {
                  type: { ...row.original, ...row.original?.user_details },
                },
              })
            }
            className="cust-btn"
          >
            <img src={view_icon} alt="View" className="edit-btn" />
          </button>
        </div>
      ),
    },
  ];

  const columnsWallet = [
    {
      Header: "S.No",
      accessor: "S.No",
      Cell: ({ row }) => <p>{row.index + 1}</p>,
    },
    { Header: "State", accessor: "State", Cell: ({ value }) => <p>{value}</p> },
    { Header: "City", accessor: "City", Cell: ({ value }) => <p>{value}</p> },
    {
      Header: "Property ID",
      accessor: "Property ID",
      Cell: ({ value }) => <p>{value}</p>,
    },
    { Header: "Type", accessor: "Type", Cell: ({ value }) => <p>{value}</p> },
    {
      Header: "Booking ID",
      accessor: "Booking ID",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Amount",
      accessor: "Amount",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Generated Date",
      accessor: "Generated Date",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Created by",
      accessor: "Created by",
      Cell: ({ value }) => <p>{value}</p>,
    },
    {
      Header: "Status",
      accessor: "Status",
      Cell: ({ value }) => <p>{value}</p>,
    },
  ];

  // Data getter logic
  const getActiveData = () => {
    switch (label) {
      case "Booking Detail":
        return {
          title: "Booking Detail",
          data: propertyList,
          columns: bookingDetail,
        };
      case "Booking Transaction":
        return {
          title: "Booking Details",
          data: bookingLists,
          columns: columnsBooking,
        };
      case "Wallet Transaction":
        return {
          title: "Wallet Transactions",
          data: walletList,
          columns: columnsWallet,
        };
      default:
        return { title: "User List View", data: [], columns: columnsProfile };
    }
  };

  const { title, data, columns } = getActiveData();

  // Render
  return (
    <>
      <Topbar header={"User List View"} subHead={"Customer"} back={true} />
      <div>
        <div className="d-flex gap-3 mb-4">
          {[
            "Profile Details",
            "Booking Detail",
            "Booking Transaction",
            "Wallet Transaction",
          ].map((ele) => (
            <div
              key={ele}
              style={{
                background: label === ele ? "#6B00D8" : "none",
                color: label === ele ? "#fff" : "#898989",
                padding: "10px 16px",
                borderRadius: 9,
                fontSize: "16px",
                fontWeight: 700,
                cursor: "pointer",
              }}
              onClick={() => handlerChangeLabel(ele)}
            >
              {ele}
            </div>
          ))}
        </div>

        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: "center",
            gap: "15px",
            justifyContent: "flex-end",
          }}
        >
          {label === "Booking Transaction" && <></>}
          {label === "Wallet Transaction" && (
            <>
              <div
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  display: "flex",
                  gap: 30,
                }}
              >
                <div style={{ display: "flex", gap: 20 }}>
                  <Select
                    className="location-search"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    displayEmpty
                    style={{ minWidth: 160 }}
                  >
                    <MenuItem value="">
                      <em>Booking ID</em>
                    </MenuItem>
                    {users.map((opt) => (
                      <MenuItem key={opt.id} value={opt.name}>
                        {opt.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <Select
                    className="location-search"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                    displayEmpty
                    style={{ minWidth: 160 }}
                  >
                    <MenuItem value="">
                      <em>State</em>
                    </MenuItem>
                    {users.map((opt) => (
                      <MenuItem key={opt.id} value={opt.name}>
                        {opt.name}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
                <div className="search-input">
                  <input
                    value={searchs}
                    onChange={(e) => setSearch(e.target.value)}
                    type="text"
                    placeholder="Search"
                    style={{ border: "none", width: "150px" }}
                  />
                  <img src={Search_icon} className="search" />
                </div>
              </div>
            </>
          )}
        </div>

        {/* Profile Details Panel */}
        {label === "Profile Details" ? (
          <>
            <div>
              <div>
                <div className="col-md-6 mb-3">
                  <label className="fw-semibold">
                    Profile Image <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="d-flex flex-column as-jc position-relative">
                    <img
                      src={type?.image ?? dummyimage}
                      style={{
                        width: "100px",
                        height: "90px",
                        borderRadius: "50px",
                      }}
                      alt=""
                    />
                  </div>
                </div>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3  f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    User ID
                  </label>{" "}
                  {type?.id}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2 "
                    style={{ width: "220px" }}
                  >
                    Name
                  </label>{" "}
                  {type?.name}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    Email ID
                  </label>{" "}
                  {type?.email}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    Mobile Number
                  </label>{" "}
                  {type?.mobile}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    WhatsUp Number
                  </label>{" "}
                  {type?.whatsapp_no}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    Gender
                  </label>{" "}
                  {type?.gender}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    Marital Status
                  </label>{" "}
                  {type?.martial_status}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    State
                  </label>{" "}
                  {type?.state_name}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    City
                  </label>{" "}
                  {type?.city_name}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    Current City/Area
                  </label>{" "}
                  {type?.current_city || "-"} / {type?.current_area || "-"}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    Pin Code
                  </label>{" "}
                  {type?.pin_code || "-"}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    DOB
                  </label>{" "}
                  {type?.dob || "-"}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    DOR
                  </label>{" "}
                  {moment(type?.dor).format("YYYY-MM-DD")}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    Booking Count
                  </label>{" "}
                  {type?.booking_count || "-"}
                </p>
              </div>
              <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-16 fs-xxl-26 mt-3 mb-3">
                Gst Details
              </h2>
              <div>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    Legal Name
                  </label>{" "}
                  {type?.legal_name ?? "-"}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    GST Number
                  </label>{" "}
                  {type?.gst_no ?? "-"}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    GST Address
                  </label>{" "}
                  {type?.gst_address ?? "-"}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    GST Contact
                  </label>{" "}
                  {type?.contact_no ?? "-"}
                </p>
                <p className="fs-xl-16 fs-12 f-w600 pb-2">
                  <label
                    className="fs-xl-16 fs-12 gray3 f-w600 pb-2"
                    style={{ width: "220px" }}
                  >
                    GST Email
                  </label>{" "}
                  {type?.gst_email ?? "-"}
                </p>
              </div>
            </div>
          </>
        ) : label === "Booking Detail" ? (
          <BookingView user_id={type?.id} />
        ) : label === "Booking Transaction" ? (
          <UserBookingTransaction user_id={type?.id} />
        ) : (
          // Table Rendering
          <Table
            columns={columns}
            setPageno={setPage}
            pagecount={pagination}
            data={data}
            show={true}
          />
        )}
      </div>
    </>
  );
}
export default CustomerView;
